import React from "react";
import styled from "@emotion/styled";
import { Tooltip } from "./Tooltip";
import withTranslator from "../Translator/withTranslation";

const CountContainer = styled.div`
    margin-top: -1.8em !important;
    border-radius: 50%;
    height: 20px;
    width: 20px;
    line-height: 17px;
`;

const OrderContainer = styled.div`
    width:max-content;
    z-index: 200;
`;

class SearchSortingComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            favouriteVillas: props.favouriteVillas ? props.favouriteVillas.length : 0,
            favouriteActive: this.props.queryString === 'search_favourite' ? true : false,
            viewedActive: this.props.queryString === 'search_viewed' ? true : false,
            viewedVillas: props.viewedVillas ? props.viewedVillas.length : 0,
            orderListOpen: false
        };
    }
    
    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
        
        var $parent = this;
        
        document.addEventListener("VillaVidFavButton_addToFavourite", this.updateFavButtonState);
    }
    
    componentDidUpdate(prevProps){
        if(prevProps.queryString !== this.props.queryString){
            this.setState({
                favouriteActive: this.props.queryString === 'search_favourite' ? true : false,
                viewedActive: this.props.queryString === 'search_viewed' ? true : false
            });
        }
    }
    
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }
    
    handleClickOutside = event => {
        if (this.orderRef && !this.orderRef.contains(event.target)) {
            this.setState({ orderListOpen: false });
        }
    };
    
    updateFavButtonState = (e) => {
        this.setState({
            favouriteVillas: e.detail.count
        });
    }
    
    setOrderRef = node => {
        this.orderRef = node;
    };
    
    goTo = (queryString, enabled) => {
        if(!enabled) return;
        
        this.setState({
            favouriteActive: queryString === 'search_favourite' ? true : false,
            viewedActive: queryString === 'search_viewed' ? true : false
        });
        
        // hide map when switch to favourite or viewed
        if(['search_favourite','search_viewed'].includes(queryString) && this.props.mapActive){
            this.showGrid();
        }
        
        this.props.onChangeQuery(queryString);
    }
    
    showGrid(){
        if(this.props.gridActive) return;
        
        this.props.onChangeGrid(true);
        
        var event = new CustomEvent("SearchSorting_viewSwitch", {
            detail: {
                view: 'grid'
            }
        });

        document.dispatchEvent(event);
    }
    
    showMap(){
        if(this.props.mapActive) return;
        
        this.props.onChangeMap(true);
        
        var event = new CustomEvent("SearchSorting_viewSwitch", {
            detail: {
                view: 'map'
            }
        });

        document.dispatchEvent(event);
    }
    
    sort = (sort) => {
        this.props.onChangeSort(sort);
        this.setState({
            orderListOpen: false
        });
    }
    
    toggle = () => {
        const open = !this.state.orderListOpen;
        
        this.setState({
            orderListOpen: open
        });
    }
    
    render(){
        const { t } = this.props;

        var enabled = {
            favourite: (this.state.favouriteVillas ) ? 1 : 0,
            viewed: (this.state.viewedVillas ) ? 1 : 0
        },
            buttonEnabled = ['disabled',''],
            countEnabled = ['bg-grey2 white','bg-green1 white'],
            iconEnabled = ['grey2','blue1'],
            resultText = '',
            pluralText = this.props.count < 2 ? this.props.resultTextSingular : this.props.resultTextPlural;
        
        if(this.props.count){
            resultText = this.props.count+' '+pluralText;    
            
            var pages = Math.ceil(this.props.count / this.props.itemsPerPage);
            if(pages > 1){
                var startRange = this.props.page > 1 ? (this.props.itemsPerPage*(this.props.page-1)) : 1,
                    endRange = ((this.props.itemsPerPage*(this.props.page)) < this.props.count ) ? (this.props.itemsPerPage*(this.props.page)) : this.props.count;
                resultText = startRange+'-'+endRange+' '+t('of')+' '+this.props.count+' '+pluralText;
            }
                    
        }
             
        return(
            <div className={(this.props.className ? this.props.className : '')}>
                <div className="flex items-center justify-sbetween">
                    <div className="font-w600 uppercase">{resultText}</div>
                    <div className="items-center flex">
                        {!this.props.hideMapButton && !this.props.mobile ?
                        <Tooltip
                        className="mr-3"
                        position="top"
                        html={
                        <button 
                            type="button" 
                            className={"btn-sm btn-tertiary " + (this.props.mapActive ? 'bor-green1' : '')} 
                            title={t('map_view')}
                            onClick={this.showMap.bind(this)}
                            ><img 
                                src="/assets/img/front/icons/marker-location-blue1.svg" 
                                alt="MAP" 
                                height="12" 
                                width="auto" 
                            />
                        </button>
                        }
                        show={t('map_view')}
                        />
                        :''}
                        {!this.props.hideGridButton && !this.props.mobile ?
                        <Tooltip 
                        className="mr-3"
                        position="top"
                        html={
                        <button 
                            type="button" 
                            className={"btn-sm btn-tertiary " + (this.props.gridActive ? 'bor-green1' : '')} 
                            title={t('grid_view')}
                            onClick={this.showGrid.bind(this)}
                            ><img 
                                src="/assets/img/front/icons/grid-blue1.svg" 
                                alt="GRID" 
                                height="12" 
                                width="auto"
                            />
                        </button>
                        }
                        show={t('grid_view')}
                        />
                        :''}
                        {!this.props.hideFavButton ?
                        <Tooltip
                        className="mr-3"
                        noLineBreak={true}
                        position="top"
                        html={
                        <button 
                            onClick={() => this.goTo('search_favourite', enabled.favourite)} 
                            className={"overflow-visible btn-tertiary btn-sm btn " +(buttonEnabled[enabled.favourite])}
                            ><img 
                                src={"/assets/img/front/icons/favourite-heart-"+(iconEnabled[enabled.favourite])+".svg"} 
                                alt="My favourite villas" 
                                height="12" 
                                width="auto" 
                                className="valign-middle no-max-width" 
                                /><CountContainer
                                    className={"absolute valign-top inline-block text-center font-80 "+(countEnabled[enabled.favourite])}
                                >{this.state.favouriteVillas}</CountContainer>
                        </button>
                        }
                        show={t('markedvillas')}
                        />
                        :''}
                        {!this.hideViewedButton ?
                        <Tooltip 
                        className="mr-3"
                        noLineBreak={true}
                        position="top"
                        html={
                        <button 
                            onClick={() => this.goTo('search_viewed', enabled.viewed)}  
                            className={"overflow-visible btn-tertiary btn-sm btn "+(buttonEnabled[enabled.viewed])}
                            ><img src={"/assets/img/front/icons/eye-"+(iconEnabled[enabled.viewed])+".svg"}
                                alt="My viewed villas"
                                height="12"
                                width="auto"
                                className="valign-middle no-max-width"
                                /><CountContainer
                                    className={"absolute valign-top inline-block text-center font-80 "+(countEnabled[enabled.viewed])}
                                >{this.props.viewedVillas ? this.props.viewedVillas.length : 0}</CountContainer>
                        </button>
                        }
                        show={t('viewedvillas')}   
                        /> 
                        :''}
                        {!this.hideOrderButton ? 
                        <div ref={this.setOrderRef} key="order">
                            {!this.state.favouriteActive && !this.state.viewedActive ?
                            <button 
                                type="button"
                                className={"flex height-100 items-center btn-sm btn-tertiary " + (this.state.gridActive ? 'bor-green1' : '')}
                                onClick={this.toggle}
                                ><img 
                                src="/assets/img/front/icons/double-arrow-sort-blue1.svg" 
                                alt="Sort" 
                                height="12" 
                                width="auto" 
                                className="pr-1"/>{t('sort')}
                            </button>
                            :''}
                            {this.state.orderListOpen ?
                            <OrderContainer className="absolute bg-white right-0 mt-2 bor-blue1 border-radius-default bor-thin bor-solid">
                                <button 
                                    type="button" 
                                    className={"btn-no bor-no bg-no px-3 py-2 font-100 width-100 block text-right "+(this.props.sort === 'price' ? 'font-w600' : '')}
                                    onClick={() => this.sort('price')}
                                >{t('lowestprice')}</button>
                                <button 
                                    type="button" 
                                    className={"btn-no bor-no bg-no px-3 py-2 font-100 width-100 block text-right "+(this.props.sort === 'reviews' ? 'font-w600' : '')}
                                    onClick={() => this.sort('reviews')}
                                >{t('bestreviewsfirst')}</button>
                                <button 
                                    type="button" 
                                    className={"btn-no bor-no bg-no px-3 py-2 font-100 width-100 block text-right "+(this.propssort === 'price-and-reviews' ? 'font-w600' : '')}
                                    onClick={() => this.sort('price-and-reviews')}        
                                >{t('lowestprice')}/{t('bestreviews')}</button>
                            </OrderContainer>
                            :''}
                        </div>
                        : ''}
                    </div>
                </div>
            </div>
        );
    }
}

export const SearchSorting = withTranslator(SearchSortingComponent);